import { useTenantsStore } from '@/stores/tenants';

export const getIsTenantWithCustomization = (): boolean => !!useTenantsStore().currentTenantDetails?.settings.hasCustomerConfiguration;
